import React from "react";
import classes from "../sections/Section.module.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";

const MapView = ({ data }) => {
  const scrollableRef = React.useRef(null);
  const [mapArr, setMapArr] = React.useState([]);

  const dateStagesArray = React.useMemo(() => {
    const array = [];
    data.forEach((item) => {
      const { date, stage, status } = item;
      const index = array.findIndex((entry) => entry.date === date);
      if (index !== -1) {
        array[index].stages.push(stage);
        array[index].status.push(status);
      } else {
        array.push({ date, stages: [stage], status: [status] });
      }
    });
    return array;
  }, [data]);

  // CHECKING WHETHER THE DATE RANGE IS MORE THAN 2 YESRS
  const dates = data.map((item) => new Date(item.date));
  const earliestDate = new Date(Math.min(...dates));
  const latestDate = new Date(Math.max(...dates));

  const yearDifference = latestDate.getFullYear() - earliestDate.getFullYear();

  React.useEffect(() => {
    function combiningDataObj(newData) {
      const combinedObj = {};

      for (const [val, data] of Object.entries(newData)) {
        const combinedData = [];
        for (const item of data) {
          combinedData.push(
            ...item.stages.map((stage, index) => ({
              date: item.date,
              stage,
              status: item.status[index],
            }))
          );
        }
        combinedObj[val] = combinedData;
      }

      const newArray = Object.entries(combinedObj).map(([key, value]) => {
        const uniqueCombinations = {};

        const uniqueData = value.filter((entry) => {
          const combination = `${entry.stage}-${entry.status}`;
          if (!uniqueCombinations[combination]) {
            uniqueCombinations[combination] = true;
            return true;
          }
          return false;
        });
        return {
          val: key,
          data: uniqueData,
        };
      });
      setMapArr(newArray);
    }

    if (yearDifference > 2) {
      const years = {};
      dateStagesArray.forEach((item) => {
        const date = new Date(item.date);
        const year = date.getFullYear();

        if (!years[year]) {
          years[year] = [];
        }
        years[year].push(item);
      });

      // combining the data

      combiningDataObj(years);
    } else {
      const quarters = {};
      dateStagesArray.forEach((item) => {
        const date = new Date(item.date);
        const year = date.getFullYear();
        const quarter = Math.ceil((date.getMonth() + 1) / 3);

        const quarterKey = `${year}-Q${quarter}`;
        if (!quarters[quarterKey]) {
          quarters[quarterKey] = [];
        }
        quarters[quarterKey].push(item);
      });

      // combining the data
      combiningDataObj(quarters);
    }
  }, [yearDifference, dateStagesArray]);

  const sortedData = mapArr.sort((a, b) => b.val - a.val);

  return (
    <div
      className={classes.sections}
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#F3F8FF",
      }}
    >
      <div
        style={{
          width: "85vw",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "7px",
        }}
      >
        <>
          <Timeline position="alternate">
            {sortedData.map((item) => (
              <>
                {" "}
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot variant="outlined" color="primary" />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", color: "#FF762B" }}
                      component="span"
                    >
                      {item.val}
                    </Typography>
                    {item.data.length !== 0 ? (
                      <>
                        {item.data.map((e) => (
                          <>
                            <div>
                              <span>
                                {new Date(e.date).toLocaleDateString()}
                              </span>
                              - <span style={{ color: "" }}>{e.stage}</span>-{" "}
                              <span style={{ color: "" }}>{e.status}</span>
                            </div>
                          </>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                  </TimelineContent>
                </TimelineItem>
              </>
            ))}
          </Timeline>
        </>
      </div>
    </div>
  );
};

export default MapView;

// old tile line

{
  /* <div
className={classes.sections}
style={{
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#F3F8FF",
}}
>
<div
  style={{
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "7px",
  }}
>
  <>
    {mapArr.map((item) => (
      <div style={{ height: "fit-content", paddingBottom: "40px" }}>
        <div className={classes.box} style={{ display: "flex" }}>
          <div className={classes.firstArrow}></div>
          <div style={{ width: "285px" }} className={classes.stageBox}>
            <p>{item.val}</p>
          </div>
          <div className={classes.secondArrow}></div>
        </div>
        <div
          ref={scrollableRef}
          style={{
            marginLeft: "10px",

            padding: "4px",
          }}
        >
          {item.data.map((e, index) => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <div key={index}>
                {" "}
                <p
                  className={classes.statusView}
                  style={{ display: "flex", gap: "15px", width: "285px" }}
                >
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* <CheckIcon style={{ color: "#35A2EB" }} /> */
}
//       <span style={{ color: "#FF762B" }}>stage : </span>
//       <span style={{ marginLeft: "0px" }}>{e.stage}</span>
//     </span>
//     <span
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//       }}
//     >
//       {/* <CheckIcon style={{ color: "#35A2EB" }} /> */}
//       <span style={{ color: "#FF762B" }}>status : </span>
//       <span style={{ marginLeft: "0px" }}>{e.status}</span>
//     </span>
//     <span>{new Date(e.date).toLocaleDateString()}</span>
//   </p>
//   <div className={classes.horizontalLine}></div>
// </div>

{
  /* <span>{new Date(e.date).toLocaleDateString()}</span>
      //         <span>{e.stage}</span> */
}
//       </div>
//     ))}
//   </div>
// </div>
//   ))}
// </>
// </div>
// </div> */}

// end

// return (
//   <div
//     className={classes.sections}
//     style={{
//       display: "flex",
//       justifyContent: "center",
//       backgroundColor: "#F3F8FF",
//     }}
//   >
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "row",
//         flexWrap: "wrap",
//         gap: "7px",
//       }}
//     >
//       {yearDifference ? (
//         <>
//           {mapArr.map((item) => (
//             <div style={{ height: "fit-content", paddingBottom: "44px" }}>
//               <div className={classes.box} style={{ display: "flex" }}>
//                 <div className={classes.firstArrow}></div>
//                 <div style={{width:"285px"}} className={classes.stageBox}>
//                   <p>{item.val}</p>
//                 </div>
//                 <div className={classes.secondArrow}></div>
//               </div>
//               <div
//                 ref={scrollableRef}
//                 style={{
//                   marginLeft: "10px",
//                   height: "500px",
//                   padding: "4px",
//                   overflow: "auto",
//                 }}
//               >
//                 {item.data.map((e, index) => (
//                   <div style={{ display: "flex",justifyContent:"space-around", height: "" }}>
//                     <div key={index}>
//                       {" "}
//                       <p
//                         className={classes.statusView}
//                         style={{ display: "flex", gap: "15px",width:"285px" }}
//                       >
//                         <span style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
//                           {/* <CheckIcon style={{ color: "#35A2EB" }} /> */}
//                           <span style={{ color: "#FF762B" }}>stage : </span>
//                           <span style={{ marginLeft: "0px" }}>{e.stage}</span>
//                         </span>
//                         <span style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
//                           {/* <CheckIcon style={{ color: "#35A2EB" }} /> */}
//                           <span style={{ color: "#FF762B" }}>status : </span>
//                           <span style={{ marginLeft: "0px" }}>
//                             {e.status}
//                           </span>
//                         </span>
//                         <span style={{ color: "#FF762B" }}>
//                           {new Date(e.date).toLocaleDateString()}
//                         </span>
//                       </p>
//                       <div className={classes.horizontalLine}></div>
//                     </div>

//                     {/* <span>{new Date(e.date).toLocaleDateString()}</span>
//                   <span>{e.stage}</span> */}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </>
//       ) : (
//         <>
//           {dateStagesArray.map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 backgroundColor: "#F3F8FF",
//               }}
//             >
//               <div>
//                 {" "}
//                 <div className={classes.box} style={{ display: "flex" }}>
//                   <div className={classes.firstArrow}></div>
//                   <div style={{width:"265px"}} className={classes.stageBox}>
//                     <p>{new Date(item.date).toLocaleDateString()}</p>
//                   </div>
//                   <div className={classes.secondArrow}></div>
//                 </div>
//                 {/* <h5> {new Date(item.date).toLocaleDateString()}</h5> */}
//                 <div style={{ display: "flex",marginLeft:"20px",justifyContent:"space-around" }}>
//                   <div>
//                     {item.stages.map((e, index) => (
//                       <div key={index}>
//                         {" "}
//                         <p
//                           className={classes.statusView}
//                           style={{ display: "flex", gap: "65px" }}
//                         >
//                           <span style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
//                             {/* <CheckIcon style={{ color: "#35A2EB" }} /> */}
//                             <span style={{ color: "#FF762B" }}>stage : </span>
//                             <sapn style={{ marginLeft: "0px" }}>{e}</sapn>
//                           </span>
//                         </p>
//                       </div>
//                     ))}
//                   </div>

//                   <div>
//                     {" "}
//                     {item.status.map((status, index) => (
//                       <>
//                         <div key={index}>
//                           {" "}
//                           <p
//                             className={classes.statusView}
//                             style={{ display: "flex", gap: "65px" }}
//                           >
//                             <span style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
//                               {/* <CheckIcon style={{ color: "#35A2EB" }} /> */}
//                               <span style={{ color: "#FF762B" }}>status : </span>
//                               <sapn style={{ marginLeft: "2px" }}>
//                                 {status}
//                               </sapn>
//                             </span>
//                           </p>
//                         </div>
//                       </>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//               <div style={{width:"265px",marginLeft:"43px"}} className={classes.horizontalLine}></div>
//             </div>
//           ))}
//         </>
//       )}
//     </div>
//   </div>
// );
